<div class="content-wrapper">
  <mat-card class="content">
    <div class="content-header">
      <h2>
        Alle betaalplannen
        <span>({{ filteredPaymentPlans().length }})</span>
      </h2>
      <mat-form-field class="mat-form-field-no-subscript">
        <mat-label>Zoeken</mat-label>
        <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
        <button
          mat-icon-button
          matSuffix
          aria-label="Zoekopdracht wissen"
          (click)="clearSearch(); $event.stopPropagation()"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>

    @if (!loadingPlans()) {
      <mat-table [dataSource]="filteredPaymentPlans()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Naam</mat-header-cell>
          <mat-cell *matCellDef="let plan">
            <p class="text-truncate">{{ plan.name }}</p>
          </mat-cell>
        </ng-container>
        <!-- Price Column -->
        <ng-container matColumnDef="price">
          <mat-header-cell *matHeaderCellDef class="hide-column-3">Prijs</mat-header-cell>
          <mat-cell *matCellDef="let plan" class="hide-column-3">
            <p class="text-truncate">{{ formatPrice(plan.startAmount) }}</p>
          </mat-cell>
        </ng-container>
        <!-- Credits Column -->
        <ng-container matColumnDef="credits">
          <mat-header-cell *matHeaderCellDef>Credits</mat-header-cell>
          <mat-cell *matCellDef="let plan">
            <p class="text-truncate">{{ plan.startCredits }}</p>
          </mat-cell>
        </ng-container>
        <!-- Limit Column -->
        <ng-container matColumnDef="limit">
          <mat-header-cell *matHeaderCellDef class="hide-column-2">Limiet</mat-header-cell>
          <mat-cell *matCellDef="let plan" class="hide-column-2">
            <p class="text-truncate">{{ plan.automaticLimit }}</p>
          </mat-cell>
        </ng-container>
        <!-- Active Column -->
        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef class="hide-column-1">Actief</mat-header-cell>
          <mat-cell *matCellDef="let plan" class="hide-column-1">
            <p class="text-truncate">{{ plan.visible ? 'Ja' : 'Nee' }}</p>
          </mat-cell>
        </ng-container>
        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let plan">
            <button
              mat-icon-button
              aria-label="Betaalplan aanpassen"
              (click)="openDialog(plan); $event.stopPropagation()"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></mat-header-row>
        <mat-row *matRowDef="let plan; columns: displayedColumns()" (click)="openDialog(plan)" matRipple></mat-row>
      </mat-table>
    } @else {
      <div class="loading-wrapper">Laden...</div>
    }
  </mat-card>

  @if (isSuperUser()) {
    <button class="add-button" mat-fab aria-label="Betaalplan aanmaken" (click)="openCreateDialog()">
      <mat-icon>add</mat-icon>
    </button>
  }
</div>
